<template>
  <div class="container-fluid section">
    <div class="row heading">
      <div class="col-12 col-lg-3">
        <h2>Agent Index</h2>
      </div>

      <div class="col-12 col-lg-9 text-right">
          <div style="width: 250px; display: inline-block;">
            <show-hide-cols
                    :cols="cols"
                    :selected="filters.columns"
            ></show-hide-cols>
              </div>

        <save-report></save-report>

          <save-chart
              :xOpts="selectedColumnObj"
              :yOpts="selectedColumnObj"
              fn="userUsers"
              :filters="filters"
          ></save-chart>

          <button class="btn btn-light" @click="showAddAgent = true;"><i class="fa fa-plus"></i> &nbsp;New Agent</button>&nbsp;
          <button class="btn btn-light" @click="clearFilters"><i class="fa fa-remove"></i> &nbsp;Clear Filters</button>&nbsp;

        <download
            fn="accounts"
            :filters="filters"
            :cols="cols"
        ></download>
        &nbsp;&nbsp;
        <paginate
                :page-count="num_pages"
                :initial-page="parseInt(filters.page - 1)"
                :page-range="1"
                :margin-pages="1"
                :click-handler="paginateClick"
                container-class="pagination"
                page-class="page-item"
                page-link-class="page-link"
                prev-class="page-item"
                prev-link-class="page-link"
                next-class="page-item"
                next-link-class="page-link"
        ></paginate>
      </div>
    </div>

    <full-table
            headerClass="table-head"
            filterClass="table-filter table-subhead"
            :cols="cols"
            :data="tableData"
            filterInputClass="form-control"
            :filters="filters"
            @filter="fetch"
    >

        <template
            v-for="col in cols"
            v-if="meta && meta[col.key]"
            :slot="col.key + '_heading'"
        >
            <span v-tooltip.bottom="metaValues(meta[col.key])">
                {{ col.display }}
                <i class="fa fa-info-circle" style="font-size: 12px;"></i>
            </span>
        </template>


        <template slot="total_mrc_filter" scope="props">

            <range-filter
                    v-model="filters.search.total_mrc"
                    label="$"
            >
            </range-filter>

        </template>

        <template slot="accounts_filter" scope="props">

            <range-filter
                    v-model="filters.search.accounts"
                    label="$"
            >
            </range-filter>

        </template>

        <template slot="accounts_data" scope="props">
            <router-link
                    :to="'/account-details?general_search=&account_status=%5B%5D&account_mrc=%5Bnull,null%5D&latest_comms=%5Bnull,null%5D&ink_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&term_date=%7B%22timeframe%22%3A%22%22,%22start%22%3A%22%22,%22end%22%3A%22%22,%22group%22%3A%22%22%7D&subagents=%5B%22' + encodeURI(props.data.name) + '%22%5D&approved=%5B%5D&estimated_comms=%5Bnull,null%5D&term=%5Bnull,null%5D&expected_spiff=%5Bnull,null%5D&actual_spiff=%5Bnull,null%5D&actual_delta=%5Bnull,null%5D&off_expected=%5Bnull,null%5D&spiff_delta=%5Bnull,null%5D&telno=&telno_carriers=&name=&carrier_name=&telno_carrier=&columns=%5B%22ink_date%22,%22term%22,%22name%22,%22carrier_name%22,%22subagents%22%5D&sort=%5B%7B%22field%22%3A%22ink_date%22,%22dir%22%3A%22DESC%22%7D%5D&page=1&limit=25'"
                    class="btn btn-light btn-sm"><i class="fa fa-external-link-square"></i>&nbsp;&nbsp;{{props.value}}</router-link>



        </template>


        <template slot="tags_filter" scope="props">

            <multi-select
                    size="sm"
                    :list="tags"
                    label="name"
                    id="name"
                    placeholder="Filter By Tag"
                    v-model="filters.search.tags"
            ></multi-select>

        </template>

        <template slot="tags_data" scope="props">
            <div>

                <button class="btn btn-light btn-sm" @click="fetchAgentTags(props.data.user_id)">
                    <i class="fa fa-tag"></i>
                </button>
            </div>
        </template>


      <template slot="name_data" scope="props">

        <router-link v-if="$canAccess(19, 1)" :to="'agents/' + props.data.user_id"> {{ props.value }} </router-link>
        <span v-else> {{ props.value }}</span>
      </template>

      <template slot="total_mrc_data" scope="props">
          {{props.value | formatMoney}}
      </template>


        <template slot="first_deal_data" scope="props">
            {{props.value | formatDate}}
        </template>
        <template slot="last_deal_data" scope="props">
            {{props.value | formatDate}}
        </template>


      <pulse-loader style="text-align:center;" slot="loading" :loading="loading" color="#5e9cd3"></pulse-loader>

    </full-table>

      <modal v-if="showAddAgent" size="lg">
          <div slot="header">
              <h3 class="modal-title d-inline d-flex justify-content-start">Add Agent</h3>
              <button @click="showAddAgent = false"  type="button" class="btn btn-clear close-btn" >
                  <i class="fa fa-remove" />
              </button>
              </h3>
          </div>
          <add-agent slot="body" @close="showAddAgent = false"></add-agent>
      </modal>

      <modal v-if="showAgentTags" size="lg" @close="closeTagWindow">
          <div slot="header">
              <h3 class="modal-title d-inline d-flex justify-content-start">Agent Tags</h3>
              <button @click="showAgentTags = false" type="button" class="btn btn-clear close-btn" >
                  <i class="fa fa-remove"  />
              </button>
              </h3>
          </div>
          <div slot="body">

              <div class="tag" v-for="t in selectedAgentTags">
                  {{t.name}}
              </div>

          </div>
      </modal>


  </div>
</template>

<script type="text/babel">
  var Paginate = require('vuejs-paginate');
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import FullTable from '../assets/FullTable.vue';
  import ShowHideCols from '../assets/ShowHideCols.vue';
  import SaveChart from '../assets/SaveChart.vue';
  import SaveReport from '../assets/SaveReport.vue';
  import Download from '../assets/Download.vue';
  import Modal from '../assets/Modal.vue';
  import AddAgent from './AddAgent.vue';
  import RangeFilter from '../assets/RangeFilter.vue';
  import MultiSelect from '../assets/MultiSelect.vue';
  import { metaData } from '../../mixins/metaData.js';

  export default {
    name: 'app',
    data () {
      return {
        filters: {
          search:{
            name: '',
            accounts: [null,null],
            total_mrc: [null, null],
            status: '',
            telno: '',
            tags: []
          },
          sort: [],
          columns:['name', 'status', 'accounts','mrc', 'referer', 'email', 'last_deal', 'telno'],
          limit: 25,
          page: 1
        },
        num_pages: 0,
        cols:[
          {
            key:        'name',
            display:    'Name',
            filter:     true,
            sortable:   true,
            width:      300

          },
            {
                key:        'tags',
                display:    'Tags',
                filter:      "Array",
                sortable:   true,
                width:      200,


            },
          {
            key:        'email',
            display:    'Email',
            filter:     true,
            sortable:   true,
            width:      300,
            style: {
            }

          },
            {
                key:        'status',
                display:    'Status',
                filter:     true,
                sortable:   true,
                width:      150
            },
            {
                key:        'accounts',
                display:    '# Accts',
                filter:     "Array",
                sortable:   true,
                width:      150,
                style: {
                    'text-align': 'right'
                }

            },
            {
                key:        'total_mrc',
                display:    'Total MRC',
                filter:     "Array",
                sortable:   true,
                width:      150,
                style: {
                    'text-align': 'right'
                }
            },
            {
                key:        'referrer',
                display:    'Referrer',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'channel',
                display:    'Channel',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'first_deal',
                display:    'First Deal',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'last_deal',
                display:    'Last Deal',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'first_deal_days',
                display:    'First Deal Days',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'last_deal_days',
                display:    'Last Deal Days',
                filter:     true,
                sortable:   true,
                width:      200
            },
            {
                key:        'telno',
                display:    'Telno',
                filter:     true,
                sortable:   true,
                width:      150
            },

        ],
        tableData:[],
        loading: false,
        showAddAgent: false,
        showAgentTags: false,
        selectedAgentTags: [],
        tags:[]
      }
    },
    components:{
        Paginate,
        FullTable,
        PulseLoader,
        ShowHideCols,
        SaveChart,
        SaveReport,
        Download,
        RangeFilter,
        Modal,
        AddAgent,
        MultiSelect

    },
      mounted(){
          if(!this.userReport_id && localStorage.getItem('agentFilters')){
              this.filters = JSON.parse(localStorage.getItem('agentFilters'));
          }
      },
    created(){
        if(!this.$canAccess(19, 9)){
            this.cols = this.cols.filter(function(col){
                console.log(col);

                return col.key != "referrer" && col.key != "channel";
            });
        }

        this.fetchTags();

    },
    computed:{
      selectedColumnObj(){
        var _this = this;
        return this.cols.filter(function (c){ return _this.filters.columns.indexOf(c.key) >= 0 });
      }
    },

    filters:{
      formatMoney(val){
          if(!val) return ' - ';
          return "$" + val;
      },
        formatDate(val){
            if(!val) return ' - ';
            return moment(val).format('MM/DD/YYYY');
        }
    },

    methods:{
        closeTagWindow(){
            this.showAgentTags = false;
            this.selectedAgentTags= []
        },
        fetchTags(){
            this.$send(this, 'tags').then(r => {
                this.tags = r.tags;
            });
        },
        fetchAgentTags(agent_id){

            this.showAgentTags = true;
            this.$send(this, 'userTags', {
                user_id: agent_id
            }).then(r => {
                this.selectedAgentTags = r.userTags;
            });


            this.selectedAgentTags = tags;
        },
        paginateClick(pageNum){
            this.filters.page = pageNum;
        },

        fetch: _.debounce(function(filters){
            this.tableData = [];
            this.filters = Object.assign({}, filters);
            this.loading = true;
            var data = filters;
            this.timer = moment().valueOf();
            data.time = this.timer;
            data.offset = this.filters.limit * (this.filters.page - 1) || 0;
            data.limit = this.filters.limit;


            this.$send(this, 'userUsers',data).then(r => {
              this.loading = false;
              if(r.time == this.timer){
                  this.tableData = r.userUsers;
                  this.num_pages = r.count;


                  if(!this.userReport_id){
                      localStorage.setItem('agentFilters', JSON.stringify(this.filters));
                  }


              }
            });

        }, 400),
        clearFilters(){
            localStorage.setItem('agentFilters', '');
            this.resetFilters();

        },
        resetFilters(){
            this.filters = {
                search:{
                    accounts: [null,null],
                    total_mrc: [null, null],
                    status: '',
                    tags:[]
                },
                sort: [],
                columns:[],
                limit: 25,
                page: 1
            }
        }
    },
    mixins: [metaData]
  }
</script>


// WEBPACK FOOTER //
// AgentIndex.vue?a900fafe